









export default {
  name: 'three-screens'

  props: ['layout', 'bgcolor', 'label', 'screen1', 'screen2', 'screen3', 'labelColor']

  data: ->
    styles:
      backgroundColor: @bgcolor
    classes: 'layout-'+@layout
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/game/ThreeScreens.vue